import React from "react";

import { Mention } from "@common/components/shared/Mention";
import { MentionsInput } from "@common/components/shared/Mention";

import defaultStyle from "@common/components/shared/Mention/defaultStyle";
import defaultMentionStyle from "@common/components/shared/Mention/defaultMentionStyle";

// use first/outer capture group to extract the full entered sequence to be replaced
// and second/inner capture group to extract search string from the match
const emailRegex = /(([^\s@]+@[^\s@]+\.[^\s@]+))$/;

function MultipleTrigger({ value, data, onChange, onAdd }) {
  return (
    <div className="multiple-triggers">
      <MentionsInput
        value={value}
        onChange={onChange}
        style={defaultStyle}
        placeholder={"Mention people using '@'"}
        a11ySuggestionsListLabel={"Suggested mentions"}
      >
        <Mention
          markup="@[__display__](user:__id__)"
          trigger="@"
          data={data}
          renderSuggestion={(
            suggestion,
            search,
            highlightedDisplay,
            index,
            focused,
          ) => (
            <div className={`user ${focused ? "focused" : ""}`}>
              {highlightedDisplay}
            </div>
          )}
          onAdd={onAdd}
          style={defaultMentionStyle}
        />
      </MentionsInput>
    </div>
  );
}

export default MultipleTrigger;
